import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import RewardsQueryComponent, {RewardsData} from "@irati/reward/apollo/query/Rewards"
import tracking from "@irati-tracking/wallet/rewardWallet"
import {RewardStatus} from "@irati/reward/enums"
import {ButtonRouterLink} from "@irati/ui/src/Link"

class WalletHeaderBalanceButtons extends PureComponent {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  handleSendCredit = () => {
    tracking.startRewardWalletSendCredit()
  }

  returnVariables = () => ({
    limit: 12,
    status: RewardStatus.ON,
    sortBy: "createdAt",
    sortDir: "DESC",
    rewardsForMyPackage: true,
    isCreditOnly: true
  })

  returnCreditReward = ({rewardCatalogueRewards}: RewardsData) => {
    const {results} = rewardCatalogueRewards

    if (results.length > 0) {
      const creditReward = results[0]
      return creditReward
    }

    return undefined
  }

  render() {
    const {apps} = this.context
    return (
      <>
        <RewardsQueryComponent variables={this.returnVariables()}>
          {(res) => {
            const creditReward = this.returnCreditReward(res.data)
            if (creditReward) {
              return (
                <ButtonRouterLink
                  primary
                  marginBottom
                  to={`/reward/${creditReward.urlSlug}`}
                  app={apps.RECOGNITION}
                  onClick={this.handleSendCredit}>
                  <FormattedMessage id="wallet.reward.sendCreditAsReward.button" />
                </ButtonRouterLink>
              )
            }
            return null
          }}
        </RewardsQueryComponent>
        <ButtonRouterLink onClick={tracking.clickBrowseRewards} to="/reward/all" app={apps.RECOGNITION}>
          <FormattedMessage id="wallet.reward.browseRewards.button" />
        </ButtonRouterLink>
      </>
    )
  }
}

export default WalletHeaderBalanceButtons
